var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1.875C12.9383 1.875 16.125 5.06221 16.125 9C16.125 12.8704 13.0467 16.0149 9.203 16.1222L9 16.125H2.43164C2.14983 16.125 1.91694 15.9156 1.88008 15.6439L1.875 15.5684V9C1.875 5.06168 5.06221 1.875 9 1.875ZM9 2.98828C5.73975 2.98828 3.08997 5.57697 2.99114 8.81262L2.98828 9V15.0117H9C12.3229 15.0117 15.0117 12.3225 15.0117 9C15.0117 5.67705 12.3225 2.98828 9 2.98828ZM9.81383 9.80357C10.0881 9.80357 10.3125 10.0446 10.3125 10.3393C10.3125 10.6094 10.1239 10.8344 9.88126 10.8701L9.81383 10.875H6.12367C5.8494 10.875 5.625 10.6339 5.625 10.3393C5.625 10.0692 5.81356 9.84412 6.05624 9.80849L6.12367 9.80357H9.81383ZM12.7174 7.125C12.9416 7.125 13.125 7.36607 13.125 7.66071C13.125 7.92857 12.9734 8.15215 12.7774 8.19059L12.7174 8.19643H6.03261C5.80842 8.19643 5.625 7.95536 5.625 7.66071C5.625 7.39286 5.77659 7.16927 5.97259 7.13084L6.03261 7.125H12.7174Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.1d0a004083407596fff2cdfcc496cc04.svg";
export { ForwardRef as ReactComponent };